var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliverooScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#98e3bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26345,
    stopColor: "#47d6bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#00ccbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095bc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.83215,53.33765c-.00024.00006-.00049.00012-.00079.00012-.08472.01825-.13861.10168-.12036.1864l3.06488,14.2829c.01062.04926.04889.08759.09766.0976l30.78943,6.42883c.08936.01837.17963-.02753.21796-.11072,2.23505-4.8728,4.45355-9.76013,6.65546-14.66205.27484-.61133.44745-1.25061.51776-1.91772,1.07922-10.18677,2.15839-20.36243,3.23755-30.5271v-.00006c.00958-.09198-.05713-.17426-.14911-.1839l-12.09222-1.26831c-.07037-.00696-.12903.01746-.17609.07324-.0285.03369-.04852.10431-.06018.21179-.7334,6.94574-1.47174,13.89062-2.21497,20.83459-.0047.04303-.01221.08051-.02271.11249-.00281.00806-.0097.01422-.01801.01611-.013.00299-.02563-.005-.0282-.01788l-3.79279-17.53955c-.04474-.20746-.17114-.28943-.37915-.24579l-11.78198,2.4538c-.00061.00012-.00122.00031-.00183.00043-.08563.01862-.13983.10358-.12109.18964l3.85034,17.87866c.00751.03705-.01624.07318-.05316.08105l-17.4184,3.62543ZM55.5072,55.98218l.13971-.37958c.33862-.92035,1.35919-1.39197,2.27954-1.05334l.40088.14752c.92035.33862,1.39191,1.35919,1.05328,2.27954l-.13965.37964c-.33862.92035-1.35919,1.39191-2.27954,1.05328l-.40088-.14746c-.92035-.33862-1.39197-1.35925-1.05334-2.2796ZM46.742,54.61383c.54395-2.24292,4.35156-1.26923,3.96887.94489-.14905.86041-.79761,1.61267-1.73035,1.64929-1.72943.06622-2.6604-.85425-2.23853-2.59418Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliverooScraper);
export default __webpack_public_path__ + "static/media/deliveroo-scraper.d9b4265bff31b9da99ea7940f2e4446e.svg";
export { ForwardRef as ReactComponent };